import { createContext } from "react";

type AuthContextType = {
	user: any;
	isAuthenticated: boolean;
	isLoading: boolean;
	error: any;
	login: () => void;
	logout: () => void;
	checkPermissions: (
		oid: string | string[],
		typ: any,
		checkUWR: boolean,
		checkSealord: boolean
	) => boolean;
	checkPreference: (
		feature: string,
		value?: string | boolean | number
	) => boolean;
	setPreference: (feature: string, value: string | boolean | number) => void;
	setPreferenceWithExpiry: (feature: string, value: number) => void;
	checkPreferenceExpired: (feature: string, defaultValue?: number) => boolean;
	token: string | null;
};
const context = createContext<AuthContextType | undefined>(undefined);

export default context;
